const {Component} = require("react");
const PropTypes = require("prop-types");
const store = require("stores/ReviewsStore");
const router = require("services/router");
const {classList} = require("helpers/html");
const Rating = require("components/widgets/Rating");
const {loaded} = require("bootstrap");

class ReviewComposer extends Component {

	static get propTypes() {
		return {
			profileId: PropTypes.number.isRequired,
			profileName: PropTypes.string.isRequired,
			reviewId: PropTypes.number
		};
	}

	get initialState() {
		return {
			current: null,
			score: null,
			contents: "",
			error: null
		};
	}

	get submitLabel() {
		return this.state.current ? "Opdater" : "Slå op";
	}

	get title() {
		return this.state.current ? "Rediger din bedømelse af" : "Bedøm din oplevelse med";
	}

	stateForReviewId(review_id) {
		if (review_id == undefined) {
			return this.initialState;
		}

		const review = store.collection.filter(review => review.id === review_id) [0];

		if (review == undefined) {
			return this.initialState;
		}

		return {
			current: review.id,
			score: parseInt(review.score),
			contents: review.contents,
			error: null
		};
	}

	constructor(props) {
		super(props);
		this.state = {loading: false, ...this.stateForReviewId(props.reviewId)};
	}

	componentDidMount() {
		this.setScoreFromQuery();
	}

	setScoreFromQuery() {
		let urlParams = new URLSearchParams(window.location.search);
		if (!urlParams.has('score')) return;

		let score = parseInt(urlParams.get('score'))
		if (typeof score !== 'number' || (score < 1 || score > 5)) return;

		this.setState({score: score});
		loaded.then(() => {
			setTimeout(() => {
				this.element.scrollIntoView({behavior: 'smooth'});
			}, 1000);
		});
	}

	onContentsChange = (e) => {
		this.setState({contents: e.target.value});
	};

	onScoreChange = (value) => {
		this.setState({score: value});
	};

	onSubmit = (e) => {
		e.preventDefault();
		e.stopPropagation();

		if (this.state.loading) {
			return;
		}

		this.setState({loading: true});

		const data = new FormData(e.target);

		// append receiver_id
		data.append("receiver_id", this.props.profileId);

		(this.state.current ? store.update(this.state.current, data) : store.create(data))
			.then((review) => {
				this.setState({loading: false, ...this.stateForReviewId(review.id)});
			})
			.catch((xhr) => {
				let response = xhr.response.data;
				if (response && response.errors) {
					const keyName = Object.keys(response.errors) [0];
					this.setState({loading: false, error: response.errors[keyName][0]});
				}
			});
	};

	render() {
		const className = classList(
			"review-composer",
			"review-box",
			this.state.loading ? "loading" : false,
			this.props.className
		);

		const errorMarkup = this.state.error ? (<p className="error-message">{this.state.error}</p>) : null;

		return (
			<div className={className} ref={el => this.element = el} >

				<div className="top-bar">
					<div className="star"><img src={router.url("img/icons/star-filled.svg")} alt="rating"/></div>
					<p>{this.title} {this.props.profileName}</p>
				</div>

				<form onSubmit={this.onSubmit}>
					<textarea name="contents" defaultValue={this.state.contents} onInput={this.onContentsChange}
										placeholder={`Skriv din oplevelse med ${this.props.profileName} her...`}/>
					<Rating name="score" className="your-rating" value={this.state.score} handleChange={this.onScoreChange}/>
					{errorMarkup}
					<input className="btn" type="submit" value={this.submitLabel}/>
				</form>

			</div>
		);
	}

}

module.exports = ReviewComposer;



// WEBPACK FOOTER //
// ./resources/js/components/frontend/ReviewComposer.js